import styled from '@emotion/styled';
import React, { useCallback } from 'react';
import HeaderWrapper from '../../component-library/navigation/NavBar/HeaderWrapper';
import LinkGroups from '../../component-library/navigation/NavBar/LinksGroup';
import Submenu from '../../component-library/navigation/NavBar/LinksGroup/Submenu';
import NavBarContainer from '../../component-library/navigation/NavBar/NavBarContainer';
import { Home, Props, useNavBar } from './common';

const LinkNavigation = styled.nav`
  pointer-events: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ContentfulDesktopBar = ({ navigationBar, initiallyTransparent }: Props) => {
  const {
    submenu,
    clearSubmenu,
    setHovered,
    linkGroups,
    navButton,
    handleNavItemSelected,
  } = useNavBar({ navigationBar });
  const isMenuOpened = !!submenu;
  const hideSubmenu = useCallback(
    (event) => {
      event.stopPropagation();
      if (!event?.target?.closest('#navbar')) {
        clearSubmenu();
      }
    },
    [clearSubmenu],
  );
  return (
    <HeaderWrapper
      initiallyTransparent={initiallyTransparent}
      overrideTransparent={isMenuOpened}
      hideNavBar={clearSubmenu}
      preventHideNavBar={isMenuOpened}
      onHover={setHovered}
    >
      {({ textColor }) => (
        <>
          <NavBarContainer>
            <Home textColor={textColor} handleNavItemClick={handleNavItemSelected} />
            <LinkNavigation>
              <LinkGroups
                textColor={textColor}
                linkGroups={linkGroups}
                handleNavItemClick={handleNavItemSelected}
              />
              {navButton}
            </LinkNavigation>
          </NavBarContainer>
          <Submenu clickOutside={hideSubmenu} links={submenu?.links} onLinkClicked={clearSubmenu} />
        </>
      )}
    </HeaderWrapper>
  );
};

export default ContentfulDesktopBar;
